import { Component, Inject, Renderer2, OnInit, HostBinding, DOCUMENT } from '@angular/core';

import { Router } from '@angular/router';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { AuthService } from './auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { UtilsService } from './shared/utils.service';
import { BehaviorSubject } from 'rxjs';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  currentColor!: string;
  isConnected = true;
  noInternetConnection!: boolean;
  token;
  private currentMessage = new BehaviorSubject<any | null>(null);
  deviceInfo: DeviceInfo | null = null;

  @HostBinding('class')
  public footerStyle!: string;

  get isDarkMode(): boolean {
    return this.currentTheme === 'theme-dark';
  }

  private currentTheme = 'theme-light';

  constructor(private router: Router,
              public utils: UtilsService,
              @Inject(DOCUMENT) private document: Document,
              private cookie: CookieService,
              private renderer: Renderer2,
              private authService: AuthService,
              private onlineStatusService: OnlineStatusService,
              private deviceService: DeviceDetectorService,
              private angularFireMessaging: AngularFireMessaging,
              private cookieService: CookieService
            ) {
              this.getDeviceInfo();

              this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
                this.isConnected = status === OnlineStatusType.ONLINE;
                this.noInternetConnection = !this.isConnected;
                console.log('Network status:', status);
              });
            }

  ngOnInit(): void {
    const consent = this.cookieService.get('cookie_consent');

    if (consent === 'accepted') {
      this.loadGoogleAnalytics();
    }

    window.addEventListener('cookieConsentAccepted', () => {
      this.loadGoogleAnalytics();
    });

    window.addEventListener('cookieConsentRejected', () => {
      console.log('Tracking scripts not loaded');
    });

    document.addEventListener('DOMContentLoaded', function() {
      if (!Notification) {
       // alert that browser does not support notifications
       return;
      }
     });

     let currentUUID = '';
     if (this.cookie.get('uuid')) {
       currentUUID = this.cookie.get('uuid');
     } else {
       currentUUID = this.utils.generateUUID();
     }
     console.log(currentUUID);
     this.cookie.set('uuid', currentUUID, 3, '/');


    this.angularFireMessaging.messages.subscribe(
      (message) => {
        console.log('Message received:', message);
        this.currentMessage.next(message);
        this.authService.newNotification.emit(message);
      },
      (error)=> { console.log('Failed to subscribe to Firebase messaging')}
      );
  
    this.currentMessage.subscribe((notificationResult) => {
      if (notificationResult) {
        console.log(notificationResult);
      }
    });


    // this.firebaseMessaging.onBackgroundMessage(function(payload) {
    //   console.log('emit', payload);
    //   this.authService.newNotification.emit(payload);
    // });

  //   this.firebaseMessaging.onBackgroundMessage(function(payload) {
  //     console.log('[firebase-messaging-sw.js] Received background message ', payload);
  //     this.currentMessage.next(payload);
  //     this.authService.newNotification.emit(payload);
  //     this.showNotify(payload);
  //     const notificationTitle = payload.notification.title;
  //     const notificationOptions = {
  //       body: payload.notification.body,
  //     };
  
  //     this.registration.showNotification(notificationTitle,
  //       notificationOptions);
  // });
    
    const userData = localStorage.getItem('user');
    if (userData) {
      this.authService.setUserData(JSON.parse(userData));
    }

    this.currentTheme = localStorage.getItem('activeTheme') || 'theme-light';
    this.renderer.setAttribute(this.document.body, 'class', this.currentTheme);
    document.documentElement.setAttribute('data-theme', this.currentTheme === 'theme-light' ? 'light' : 'dark');
  }

  getDeviceInfo() {
    if (this.cookie.get('deviceInfo')) {
      this.deviceInfo = JSON.parse(this.cookie.get('deviceInfo'));
    } else {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      this.cookie.set('deviceInfo',  JSON.stringify(this.deviceInfo), 3, '/');
    }
  }

  navigateTo(page: any) {
    this.router.navigate([page]);
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  userType() {
    return this.authService.getUserData()?.type;
  }

  switchMode(isDarkMode: boolean) {
    this.currentTheme = isDarkMode ? 'theme-dark' : 'theme-light';
    this.currentColor = isDarkMode ? 'dark' : 'light';
    this.renderer.setAttribute(this.document.body, 'class', this.currentTheme);
    document.documentElement.setAttribute('data-theme', this.currentColor);
    this.utils.setTheme(this.currentTheme as 'theme-light' | 'theme-dark');
  }

  loadGoogleAnalytics() {
    if (document.getElementById('ga-script')) return;

    const script = document.createElement('script');
    script.id = 'ga-script';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-JKSJB4JV26';
    script.async = true;
    document.head.appendChild(script);

    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      (window as any).dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', 'G-JKSJB4JV26');
  }
}
